<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Whatsapp:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'WhatsappText')"
            [blockData]="block.variables?.WhatsappText ?? ''"
            [placeholder]="whatsappTextPlaceholder"
            [maxLength]="4000"
            variable="WhatsappText"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'link'"
            (handleOnChange)="onChange($event, 'WhatsappCtaText')"
            [blockData]="block.variables?.WhatsappCtaText ?? ''"
            [placeholder]="whatsappCtaTextPlaceholder"
            [maxLength]="4000"
            variable="WhatsappCtaText"
          >
          </app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'WhatsappCtaLink')"
            [blockData]="block.variables?.WhatsappCtaLink ?? ''"
            [placeholder]="whatsappCtaLinkPlaceholder"
            [maxLength]="4000"
            variable="WhatsappCtaLink"
          ></app-block-text>
        </div>
      </div>
      <div class="col-12">
        <app-block-text
          [type]="'content'"
          (handleOnChange)="onChange($event, 'WhatsappImage')"
          [blockData]="block.variables?.WhatsappImage ?? ''"
          [placeholder]="whatsappImagePlaceholder"
          [maxLength]="4000"
          variable="WhatsappImage"
          [isImage]="true"
        ></app-block-text>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side whatsapp-preview" [class.mobile-preview]="isPreview">
        <!-- Custom Phone Frame (only shown in preview mode) -->
        <div *ngIf="isPreview" class="phone-frame">
          <div class="phone-screen">
            <!-- Status Bar -->
            <div class="status-bar">
              <span class="time">{{ currentTime }}</span>
              <span class="icons">
                <span>📶</span><span>🔋</span>
              </span>
            </div>

            <!-- WhatsApp App Content -->
            <div class="screen-content">
              <!-- WhatsApp Header -->
              <div class="whatsapp-header">
                <span class="back-arrow">‹</span>
                <div class="avatar">V</div>
                <span class="contact-name">Valamar</span>
              </div>

              <!-- Message Bubble -->
              <div class="whatsapp-message-container">
                <div class="message-bubble">
                  <!-- Text Content -->
                  <div class="message-text" [innerHTML]="$safeNavigationMigration(block.variables?.WhatsappText)"></div>

                  <!-- Image -->
                  <div class="message-image" *ngIf="block.variables?.WhatsappImage">
                    <img [src]="$safeNavigationMigration(block.variables?.WhatsappImage)" alt="WhatsApp Image"/>
                  </div>

                  <!-- CTA Button -->
                  <a
                    *ngIf="block.variables?.WhatsappCtaLink && block.variables?.WhatsappCtaText"
                    class="message-cta"
                    [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.WhatsappCtaLink))"
                    target="_blank"
                  >
                    {{ block.variables?.WhatsappCtaText }}
                  </a>

                  <div class="message-time">{{ currentTime }}</div>
                </div>
              </div>
            </div>

            <!-- Home Indicator -->
            <div class="home-indicator"></div>
          </div>
        </div>

        <!-- Regular preview (edit mode) -->
        <div *ngIf="!isPreview" class="whatsapp-message">
          <!-- Text Content -->
          <div
            class="whatsapp-text"
            [innerHTML]="$safeNavigationMigration(block.variables?.WhatsappText)"
          ></div>

          <!-- Image -->
          <div class="whatsapp-image" *ngIf="block.variables?.WhatsappImage">
            <img
              [src]="$safeNavigationMigration(block.variables?.WhatsappImage)"
              alt="Whatsapp Image"
            />
          </div>

          <!-- CTA Button -->
          <a
            *ngIf="
              block.variables?.WhatsappCtaLink &&
              block.variables?.WhatsappCtaText
            "
            class="whatsapp-cta-btn"
            [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.WhatsappCtaLink))"
            target="_blank"
          >
            {{ block.variables?.WhatsappCtaText }}
          </a>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
